// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import ChevronRight20 from './ChevronRight20';
import ChevronRight24 from './ChevronRight24';
import ChevronRight40 from './ChevronRight40';
import ChevronRight48 from './ChevronRight48';

type ChevronRightProps = {
    variation: '20' | '24' | '40' | '48';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    ChevronRight20,
    ChevronRight24,
    ChevronRight40,
    ChevronRight48,
};

const ChevronRight: FC<ChevronRightProps> = ({ variation, ...props }) => {
    const variationKey = `ChevronRight${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"ChevronRight" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default ChevronRight;
